import { Handle, Position, type NodeProps } from "@xyflow/react";

import type { BrainFlowNodeData } from "../brainToFlow";

export default function BrainCategoryNode({ data }: NodeProps) {
  const d = data as BrainFlowNodeData;
  const selected = !!d.selected;
  return (
    <div
      className="nopan flex min-w-[112px] max-w-[140px] cursor-pointer items-center gap-2 rounded-full border px-3 py-2 shadow-sm transition-shadow hover:shadow-md"
      style={{
        backgroundColor: d.fill || "#f8fafc",
        borderColor: selected ? d.color || "#334155" : "#e2e8f0",
        boxShadow: selected ? `0 0 0 2px ${d.color || "#334155"}33` : undefined,
      }}
    >
      <Handle type="target" position={Position.Left} className="!opacity-0" />
      <Handle type="target" position={Position.Right} className="!opacity-0" />
      <Handle type="target" position={Position.Top} className="!opacity-0" />
      <Handle type="target" position={Position.Bottom} className="!opacity-0" />
      <Handle type="source" position={Position.Left} id="s-l" className="!opacity-0" />
      <Handle type="source" position={Position.Right} id="s-r" className="!opacity-0" />
      <Handle type="source" position={Position.Top} id="s-t" className="!opacity-0" />
      <Handle type="source" position={Position.Bottom} id="s-b" className="!opacity-0" />
      <span
        className="h-2.5 w-2.5 shrink-0 rounded-full"
        style={{ backgroundColor: d.color || "#64748b" }}
      />
      <div className="min-w-0 flex-1">
        <div className="truncate text-[11px] font-semibold text-slate-800">{d.label}</div>
      </div>
      {typeof d.count === "number" ? (
        <span className="text-[10px] font-medium text-slate-500">{d.count}</span>
      ) : null}
    </div>
  );
}
